export enum SettingsTabNames {
  General = 'General',
  SMS = 'SMS',
  Email = 'Email',
  Autoline = 'Autoline',
  SiblingBrands = 'SiblingBrands',
  Oorjit = 'Oorjit',
  FacebookLeadsApi = 'FacebookLeadsApi',
  TiktokokLeadsApi = 'TiktokLeadsApi',
  LinkedInLeadsApi = 'LinkedInLeadsApi',
  AzureAd = 'AzureAd',
  Outlook = 'Outlook',
  OneDrive = 'OneDrive',
  Quotation = 'Quotation',
  Booking = 'Booking',
  PreBooking = 'Pre-Booking',
  LeadDistribution = 'Lead Distribution',
  CompanyAssignment = 'Company Assignment',
  LeadActivity = 'LeadActivity',
  ShortenUrl = 'ShortenUrl',
  PDF = 'PDF',
  Application = 'Application',
  CloudFront = 'CloudFront',
  NotificationSettings = 'Notification Settings',
  SocialMediaLinks = 'SocialMediaLinks',
  LeadLostApprovalSettings = 'LeadLostApprovalSettings',
  AiApiSettings = 'Ai Engine Api Settings',
  FollowUpGapTime = 'Follow Up Time Settings',
  FollowupSettings = 'Followup Settings',
  AppNotificationSettings = 'App Notification Settings',
  StageToMustFieldMapping = 'Stage To Must Field Mapping',
  WhatsApp = 'WhatsApp',
  InvoiceSettings = 'Invoice Settings',
  VehicleReportSettings = 'Vehicle Report Settings',
  HolidaySettings = 'Holiday Settings',
  ActivitySettings = 'Activity Settings',
  UserbackSettings = 'Userback Settings',
  CheckList = 'Check List',
  WhatsappLeadAssignment = 'Whatsapp Lead Assignment Settings',
  PackagePriceCalculation = 'Package Price Calculation',
  ServiceAdvisorSettings = 'Service Advisor Settings',
  BodyShopSettings = 'Body Shop Settings',
  DeliveryFollowUpGapTime = 'Delivery Follow Up Time Settings',
  RequirementSettings = 'Requirement Settings',
}
